import { render, staticRenderFns } from "./SolrSelect.vue?vue&type=template&id=685c2d38&scoped=true&"
import script from "./SolrSelect.vue?vue&type=script&lang=js&"
export * from "./SolrSelect.vue?vue&type=script&lang=js&"
import style0 from "./SolrSelect.vue?vue&type=style&index=0&id=685c2d38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685c2d38",
  null
  
)

export default component.exports